import type { FinancialOverview } from '../../lib/financialsApi';
import { MetricCard } from './MetricCard';
import { useI18n } from '../../contexts/I18nContext';

interface FinancialsDashboardProps {
  overview: FinancialOverview;
}

function formatMoney(amount: number, currency: string): string {
  return `${amount.toLocaleString('ro-RO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
}

/** Metric cards for the business-level P&L, with optional period comparison. */
export function FinancialsDashboard({ overview }: FinancialsDashboardProps) {
  const { t } = useI18n();
  const { current, change } = overview;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        label={t('financials.metric.totalRevenue')}
        value={formatMoney(current.totalRevenue, current.currency)}
        change={change?.revenueChange}
      />
      <MetricCard
        label={t('financials.metric.totalExpenses')}
        value={formatMoney(current.totalExpenses, current.currency)}
        change={change?.expensesChange}
        positiveIsGood={false}
      />
      <MetricCard
        label={t('financials.metric.profit')}
        value={formatMoney(current.profit, current.currency)}
        change={change?.profitChange}
      />
      <MetricCard
        label={t('financials.metric.profitMargin')}
        value={`${current.profitMargin.toFixed(1)}%`}
        change={change?.marginChange}
      />
    </div>
  );
}
